import isNil from 'lodash/isNil';

export const isEmpty = (value: any) => {
  return isNil(value) || value === '' || Number.isNaN(value);
};
